import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_GEO_SEGMENTATION_SEARCH_LIST_REQUEST, GET_TAX_ID_SEARCH_LIST_REQUEST, GET_TOP_SEARCHED_LIST_REQUEST, PROVIDER_SEARCH_REQUEST, SAVE_GEO_SEARCH_DETAILS_REQUEST, SAVE_SEARCH_DETAILS_REQUEST, SAVE_CONTRACT_SEARCH_DETAILS_REQUEST, SAVE_TINS_GROUP_REQUEST } from '@src/middleware/actions/actionTypes';
import {
  fetchTopSearchedListSuccess,
  fetchTopSearchedListError,
  userDetailsFetched,
  providerSearchSuccess,
  providerSearchFailure,
  fetchTaxIdSearchListSuccess,
  fetchTaxIdSearchListFailure,
  fetchGeoSegmentationSearchListSuccess,
  fetchGeoSegmentationSearchListFailure,
  saveSearchDetailsFailure,
  saveSearchDetailsSuccess,
  saveContractSearchDetailsFailure,
  saveContractSearchDetailsSuccess,
  saveTinsGroupFailure,
  saveTinsGroupSuccess,
  saveGeoSearchDetailsFailure,
  saveGeoSearchDetailsSuccess,
  providerSearchLoading,
} from '@src/middleware/actions/ProviderSearchAction/ProviderSearchAction';
import {
  fetchUserSavedTins,
  getGeoSegmentationSearchList, getProviderSearchList,
  getPSMSProviderSearchList,
  getPSMSTaxIdSearchList,
  getTaxIdSearchList, getTopSearchedList, saveGeoSearchDetails, psmsSaveGeoSearchDetails,
  saveSearchDetails, psmsSaveSearchDetails, saveTinsGroup, saveContractSearchDetails, getMultiContractIdSearchList
} from '@src/middleware/services/providerSearch/ProviderSearch.service';
import APP_CONSTANT from '@src/CommonComponents/ChangeProviderComponent/constant';
import { getLoggedUser } from '@src/utility/createStorage';
export const handleError = (message: string, error: any): void => {
  console.error(`[Error] ${message}`, error);
};

const isPSMSReportCardClicked = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';

export function* fetchTopSearchedList(action: any) {
  try {
    // configLoggedUser();




    const _userDetails = JSON.parse(getLoggedUser() ?? '{}');
    const userDetail = {
      userId: _userDetails?.MsId ?? '',
      userType:
        (Array.isArray(_userDetails?.UserPersonas) &&
          _userDetails?.UserPersonas.length &&
          _userDetails?.UserPersonas[0]?.UserType) ||
        '',
    };

    if (userDetail.userId && userDetail.userType) {
      yield put(userDetailsFetched({ userDetail }));
    }

    const {
      PAYLOAD_PROPS,
      STATUS_CODE,
    } = APP_CONSTANT;
    const response = yield call(getTopSearchedList);


    if (Array.isArray(response[0]?.TinDetails) && response[0]?.TinDetails.length) {
      const tinDetails = response[0].TinDetails;
      const payload = {
        searchValue: tinDetails.map(item => item?.Tin).join(','),
        type: PAYLOAD_PROPS.multiTaxIdSearchType,
        page: PAYLOAD_PROPS.searchPage,
        limit: PAYLOAD_PROPS.searchLimit,
      };

      const taxIdSearchRes = yield call(getTaxIdSearchList, payload);

      if (taxIdSearchRes?.StatusCode === STATUS_CODE?.OK) {
        const tinNameMap = new Map(
          taxIdSearchRes.Data?.map(dataItem => [dataItem?.Tin, dataItem?.TinName])
        );

        tinDetails.forEach(item => {
          item['TinName'] = tinNameMap.get(item?.Tin) || '';
        });
      }
    }
    let userSavedTinGroups = [];
    if (_userDetails?.MsId) {
      const userSavedTinsResponse = yield call(fetchUserSavedTins, { UserId: _userDetails.MsId });
      if (userSavedTinsResponse?.StatusCode === STATUS_CODE?.OK) {
        userSavedTinGroups = userSavedTinsResponse.Data || [];
      }
    }

    const contractRollUp = response[0]?.ContractSearchRollUpDetails?.slice(0, 5) || [];
    if (contractRollUp.length) {
      // Batched lookup replaces per-contract calls; on any failure/invalid contract, TinCount defaults to 0.
      let tinCountByContractId: Record<string, number> = {};
      try {
        const contractIds = contractRollUp.map((item) => String(item?.SearchedContractId));
        const multiContractRes: any = yield call(getMultiContractIdSearchList, { searchValue: contractIds.join(',') });
        if (multiContractRes?.StatusCode === STATUS_CODE?.OK) {
          const validContracts = multiContractRes?.Data?.ValidContracts || [];
          tinCountByContractId = validContracts.reduce((acc: Record<string, number>, contract: any) => {
            acc[String(contract?.ContractId)] = contract?.TinCount ?? 0;
            return acc;
          }, {});
        }
      } catch {
        tinCountByContractId = {};
      }
      response[0].ContractSearchRollUpDetails = contractRollUp.map((item) => ({
        ...item,
        TinCount: tinCountByContractId[String(item?.SearchedContractId)] ?? 0,
      }));
    }

    if (response) {
      yield put(fetchTopSearchedListSuccess({ response, userSavedTinGroups }));
    }
  } catch (error) {
    handleError('Error in fetchTopSearchedList:', error);
    yield put(fetchTopSearchedListError(error));
  }
}

export function* fetchProviderSearch(action: any) {
  try {
    yield put(providerSearchLoading(true));
    const ispsms = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';
    const response = yield call(ispsms ? getPSMSProviderSearchList : getProviderSearchList, action.payload);
    yield put(providerSearchSuccess(response));

  } catch (error) {
    handleError('Error in fetchProviderSearch:', error);
    yield put(providerSearchFailure(error));
  }
}


export function* fetchTaxIdSearchList(action: any) {
  try {
    yield put(providerSearchLoading(true));
    const ispsms = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';
    const response = yield call(ispsms ? getPSMSTaxIdSearchList : getTaxIdSearchList, action.payload);
    if (response?.StatusCode === 200) {

      const { PAYLOAD_PROPS } = APP_CONSTANT;
      let options = response?.Data ?? [];

      if (action.payload.type !== PAYLOAD_PROPS.taxNameSearchType) {
        options = options.sort((a, b) => Number(b?.value) - Number(a?.value));
      }

      yield put(fetchTaxIdSearchListSuccess(options));
    } else {
      handleError('API Error in fetchTaxIdSearchList:', response?.ErrorMessage || 'Unknown error');
      yield put(fetchTaxIdSearchListFailure(response));
    }
  } catch (error) {
    handleError('Error in fetchTaxIdSearchList:', error);
    yield put(fetchTaxIdSearchListFailure(error));
  }
}


export function* fetchGeoSegmentationSearchList(action: any) {
  try {
    yield put(providerSearchLoading(true));
    const response = yield call(getGeoSegmentationSearchList, action.payload);
    if (response?.StatusCode === 200) {
      yield put(fetchGeoSegmentationSearchListSuccess(response?.Data ?? []));
    } else {
      handleError('API Error in fetchGeoSegmentationSearchList:', response?.ErrorMessage || 'Unknown error');
      yield put(fetchGeoSegmentationSearchListFailure(response));
    }
  } catch (error) {
    handleError('Error in fetchGeoSegmentationSearchList:', error);
    yield put(fetchGeoSegmentationSearchListFailure(error));
  }
}


export function* saveSearchDetailsSaga(action: any) {
  try {
    const ispsms = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';
    const response = yield call(ispsms ? psmsSaveSearchDetails : saveSearchDetails, action.payload);
    if (response?.StatusCode === 200) {
      yield put(saveSearchDetailsSuccess(response));
    } else {
      handleError('API Error in saveSearchDetailsSaga:', response?.ErrorMessage || 'Unknown error');
      yield put(saveSearchDetailsFailure(response));
    }
  } catch (error) {
    handleError('Error in saveSearchDetailsSaga:', error);
    yield put(saveSearchDetailsFailure(error));
  }
}


export function* saveTinsGroupSaga(action: any) {
  try {
    const response = yield call(saveTinsGroup, action.payload);
    if (response?.StatusCode === 200) {
      yield put(saveTinsGroupSuccess(response));
    } else {
      handleError('API Error in saveTinsGroupSaga:', response?.ErrorMessage || 'Unknown error');
      yield put(saveTinsGroupFailure(response));
    }
  } catch (error) {
    handleError('Error in saveTinsGroupSaga:', error);
    yield put(saveTinsGroupFailure(error));
  }
}


export function* saveContractSearchDetailsSaga(action: any) {
  try {
    const response = yield call(saveContractSearchDetails, action.payload);
    if (response?.StatusCode === 200) {
      yield put(saveContractSearchDetailsSuccess(response));
    } else {
      handleError('API Error in saveContractSearchDetailsSaga:', response?.ErrorMessage || 'Unknown error');
      yield put(saveContractSearchDetailsFailure(response));
    }
  } catch (error) {
    handleError('Error in saveContractSearchDetailsSaga:', error);
    yield put(saveContractSearchDetailsFailure(error));
  }
}


export function* saveGeoSearchDetailsSaga(action: any) {
  try {
    const ispsms = sessionStorage.getItem('isPSMSReportCardClicked') === 'true';
    const response = yield call(ispsms ? psmsSaveGeoSearchDetails : saveGeoSearchDetails, action.payload.payload);
    if (response?.StatusCode === 200) {
      yield put(saveGeoSearchDetailsSuccess({ response, navigateTo: action.payload.navigateTo }));
    } else {
      handleError('API Error in saveGeoSearchDetailsSaga:', response?.ErrorMessage || 'Unknown error');
      yield put(saveGeoSearchDetailsFailure(response));
    }
  } catch (error) {
    handleError('Error in saveGeoSearchDetailsSaga:', error);
    yield put(saveGeoSearchDetailsFailure(error));
  }
}

export function* providerSearchSaga() {
  yield takeLatest(GET_TOP_SEARCHED_LIST_REQUEST, fetchTopSearchedList);
  yield takeLatest(PROVIDER_SEARCH_REQUEST, fetchProviderSearch);
  yield takeLatest(GET_TAX_ID_SEARCH_LIST_REQUEST, fetchTaxIdSearchList);
  yield takeLatest(GET_GEO_SEGMENTATION_SEARCH_LIST_REQUEST, fetchGeoSegmentationSearchList);
  yield takeLatest(SAVE_SEARCH_DETAILS_REQUEST, saveSearchDetailsSaga);
  yield takeLatest(SAVE_CONTRACT_SEARCH_DETAILS_REQUEST, saveContractSearchDetailsSaga);
  yield takeLatest(SAVE_TINS_GROUP_REQUEST, saveTinsGroupSaga);
  yield takeLatest(SAVE_GEO_SEARCH_DETAILS_REQUEST, saveGeoSearchDetailsSaga);
}


export default [providerSearchSaga];